<template>
  <div>
    <p class="light-gray">
      {{ $t('placeholder.age') }}
    </p>
    <Slider
      :value="trainerAge"
      :min-value="minAge"
      :max-value="maxAge"
      :post-str="$t('common.years')"
      class="age-slider"
      @changeValue="getAge"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import constants from '@/dependencies/constants'
import Slider from '~/components/Common/Slider'

export default {
  name: 'Age',
  components: {
    Slider
  },
  data() {
    return {
      defaultAge: [constants.COMMON.MIN_AGE, constants.COMMON.MAX_AGE],
      age: null
    }
  },
  computed: {
    ...mapGetters({
      searchAge: 'search/searchAge'
    }),
    minAge() {
      return constants.COMMON.MIN_AGE
    },
    maxAge() {
      return constants.COMMON.MAX_AGE
    },
    trainerAge() {
      return this.searchAge ? this.searchAge : this.defaultAge
    }
  },
  methods: {
    ...mapActions({
      setAge: 'search/SET_AGE'
    }),
    getAge(age) {
      this.age = age
      this.setAge(age)
    }
  }
}
</script>

<style scoped></style>
